import React from 'react';
import Header from './Header';
import Sidebar from './Sidebar';

export interface MobileLayoutProps {
  children: React.ReactNode;
  showSidebar?: boolean;
  onToggleSidebar?: () => void;
  className?: string;
}

const MobileLayout: React.FC<MobileLayoutProps> = ({
  children,
  showSidebar = false,
  onToggleSidebar,
  className = ''
}) => {
  return (
    <div className={`min-h-screen bg-gray-50 ${className}`}>
      {/* Header */}
      <Header onToggleSidebar={onToggleSidebar || (() => {})} />
      
      {/* Main content area */}
      <div className="flex">
        {/* Sidebar */}
        <Sidebar isOpen={showSidebar} onClose={() => onToggleSidebar?.()} />
        
        {/* Main content */}
        <main className="flex-1 min-h-screen">
          <div className="px-4 py-6 sm:px-6 lg:px-8">
            {children}
          </div>
        </main>
      </div>
      
      {/* Mobile sidebar overlay */}
      {showSidebar && (
        <div
          className="fixed inset-0 z-40 bg-black bg-opacity-50 lg:hidden"
          onClick={() => onToggleSidebar?.()}
        />
      )}
    </div>
  );
};

export default MobileLayout;
